import { Component } from '@angular/core';
import { OnInit, ViewChild } from '@angular/core';

import { AgGridAngular } from 'ag-grid-angular';
import { GridOptions, SortChangedEvent, PaginationChangedEvent, Column } from 'ag-grid-community';

import { AlertsService } from '../../../services/alerts.service';
import { WorkflowQueryService } from '../../services/workflow-query.service';
import { UserService } from '../../../services/user.service';

/**
 * Component for selecting workflow entity extraction queries.
 * Displays a grid allowing users to select individual NER entity categories.
 * Grid is implemented using AG Grid
 * API ref: https://www.ag-grid.com/angular-data-grid/grid-api
 * Event API ref: https://www.ag-grid.com/angular-data-grid/grid-events
 * Column properties ref: https://www.ag-grid.com/angular-data-grid/column-properties
 */
@Component({
	selector: 'workflow-ner-selector',
	templateUrl: './ner-selector-ag.component.html',
	styleUrl: './ner-selector-ag.component.css'
})
export class NerSelectorAgComponent implements OnInit {
	@ViewChild('kvGrid') grid!: AgGridAngular;

	LOCALIZATION: any;

	inprogress: boolean = false;

	// Properties applied to all columns
	defaultColDef = {
		flex: 1
	};

	columns: any[] = [
		{ field: 'field', hide: true },
		{ field: 'name', headerName: 'Name', sortable: true, filter: false, tooltipField: 'name' },
		{
			field: 'category', headerName: 'Category', sortable: true, filter: false,
			valueGetter: (params: any) => params.data?.category || 'None',
			tooltipValueGetter: (params: any) => params.data?.category || 'None'
		},
		{
			field: 'eCodes', headerName: 'Exemption Codes', sortable: true, filter: false,
			valueGetter: (params: any) => params.data?.eCodes || 'None',
			tooltipValueGetter: (params: any) => params.data?.eCodes || 'None'
		},
		{
			field: 'color', headerName: 'Color', sortable: false, filter: false,
			tooltipField: 'color',
			cellStyle: (params: any) => ({
			  backgroundColor: params.value || 'transparent',
			  color: params.value ? 'white' : 'black',
			  textAlign: 'center',
			})
		}
	];

	gridOptions: GridOptions = {
		rowSelection: {
			mode: 'multiRow',
			headerCheckbox: true
		}
	};

	gridData: any[] = [];
	selectedRows: any[] = [];

	constructor(
		private alertsService: AlertsService,
		private workflowQueryService: WorkflowQueryService,
		private userService: UserService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;

		this.loadNER();
	}

	private loadNER(page?: number): void {
		this.inprogress = true;

		this.workflowQueryService.getNER().then(
			(data: any) => {
				// All data is returned at once.
				this.gridData = data || [];
				this.inprogress = false;
			},
			(err) => {
				console.error("Failed to load ner queries", err);

				this.gridData = [];
				this.inprogress = false;

				this.alertsService.error({
					message: "Failed to retrieve entity extraction options."
				});
			}
		);
	}

	onGridReady(event: any) {
		// Empty
	}

	onSelectionChanged() {
		this.selectedRows = this.grid.api.getSelectedRows();
		this.processSelected();
	}

	private processSelected() {
		console.log(this.selectedRows);

		this.workflowQueryService.clearSelectedNER();

		let selections: string[] = [];
		this.selectedRows.forEach((row: any) => {
			selections.push(row.field);
		});
		this.workflowQueryService.setSelectedNER(selections);
	}
}
